<template>
    <div class="grid">
        <div class="col-12">
            <div class="p-fluid">
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">NIK</label>
                    <div class="col-12 md:col-5">
                        {{ model.nik }}
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Name</label>
                    <div class="col-12 md:col-5">
                        {{ model.name }}
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Placement</label>
                    <div class="col-12 md:col-5">
                        <Dropdown
                            v-model="model.placement_id" :options="placements" optionLabel="name" optionValue="id"
                            placeholder="Select Placement" disabled="true" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Division</label>
                    <div class="col-12 md:col-5">
                        <Dropdown v-model="model.division_id"
                            :options="divisions" optionLabel="name" optionValue="id" placeholder="Select Division"
                         disabled="true" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Position</label>
                    <div class="col-12 md:col-5">
                        <Dropdown v-model="model.position_id"
                            :options="positions" optionLabel="name" optionValue="id" placeholder="Select Position"
                         disabled="true" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Position Class</label>
                    <div class="col-12 md:col-5">
                        <Dropdown
                            v-model="model.position_class_Id" :options="positionClasses" optionLabel="name"
                            optionValue="id" placeholder="Select Position Class" disabled="true" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Start Assessement</label>
                    <div class="col-12 md:col-5">
                        <Calendar :showIcon="true" :showButtonBar="true"
                            :disabled="disabled"
                            :class="{ 'p-invalid': submitted && !form.start_date }" v-model="form.start_date"
                            dateFormat="yy-mm-dd" />
                        <small class="p-invalid" v-if="submitted && !form.start_date">Start Date is required.</small>
                    </div>
                    <div class="col-12 mt-2 md:col-1">
                        <label for="name3">End Assessement</label>
                    </div>
                    <div class="col-12 md:col-4">
                        <Calendar :showIcon="true" :showButtonBar="true"
                            :disabled="disabled"
                            :class="{ 'p-invalid': submitted && !form.end_date }" v-model="form.end_date"
                            dateFormat="yy-mm-dd" />
                        <small class="p-invalid" v-if="submitted && !form.end_date">End Date is required.</small>
                    </div>
                </div>
                <hr />
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Assessor Name</label>
                    <div class="col-12 md:col-5">
                        <AutoComplete forceSelection placeholder="Search" id="dd" :dropdown="true"
                            :disabled="disabled"
                            v-model="form.assessor" :suggestions="autoFilteredValue"
                            @complete="searchAssessor($event)" @item-select="selectAssessor" field="name"
                            :class="{ 'p-invalid': submitted && !form.assessor }"
                         />
                        <small class="p-invalid" v-if="submitted && !form.assessor">
                            Assessor is required.
                        </small>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Assessor Position</label>
                    <div class="col-12 md:col-5">
                        {{ assessorPosition }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AutoComplete from 'primevue/autocomplete';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import axios from 'axios';
export default {
    components: {
        AutoComplete,
        Calendar,
        Dropdown,
        InputText,
    },
    props: ['model','submitted','disabled'],
    data() {
        return {
            form: this.$page.props.assessement ?
                 {start_date: this.$page.props.assessement.start_date,
                    end_date: this.$page.props.assessement.end_date,
                    assessor_id: this.$page.props.assessement.assessor_id} :
                 {start_date: '', end_date: '', assessor_id: ''},
            placements: [],
            divisions: [],
            positions: [],
            positionClasses: [],
            employees: [],
            autoFilteredValue: [],
            assessorPosition: '',
        }
    },
    mounted() {
        if(this.$page.props.assessement){
            this.form.assessor_id = this.$page.props.assessement.assessor_id;
            this.form.assessor = this.$page.props.assessement;
            this.selectAssessor();
        }
        this.loadData();
    },
    methods: {
        searchAssessor(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    axios.get(`${this.$page.props.appUrl}api/employees`)
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                }
                else {
                    let filterValue = event.query.toLowerCase();
                    axios.get(`${this.$page.props.appUrl}api/employees?search=${filterValue}`)
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                }
            }, 250);
        },
        selectAssessor() {
            axios.get(`${this.$page.props.appUrl}api/employees/${this.form.assessor.id}`)
            .then((data) => {
                this.form.assessor_id = data.data.data.id;
                this.assessorPosition = data.data.data.position.name;
            });
        },
        loadData() {
            axios.get(`${this.$page.props.appUrl}api/placement-units`)
                .then((data) => {
                    this.placements = data.data;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                });
            axios.get(`${this.$page.props.appUrl}api/divisions`)
                .then((data) => {
                    this.divisions = data.data;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Divisions, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                });
            axios.get(`${this.$page.props.appUrl}api/positions`)
                .then((data) => {
                    this.positions = data.data;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Positions, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                });
            axios.get(`${this.$page.props.appUrl}api/position-classes`)
                .then((data) => {
                    this.positionClasses = data.data;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Positions, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                });
            axios.get(`${this.$page.props.appUrl}api/employees`)
                .then((data) => {
                    this.employees = data.data.data;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Employees, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                });
        }
    }
}
</script>
